import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { abogadoPorId, inicialesDe } from '../../data/abogados';
import { useDatos } from '../../contexts/DatosContext';
import { Avatar } from '../ui/Etiquetas';
import type { Expediente, Plazo } from '../../types';
import { plazosVigentes } from '../../utils/consultas';
export function AbogadosAsignados({
  expediente,
  plazos
}: {
  expediente: Expediente;
  plazos: Plazo[];
}) {
  const {
    sucursales
  } = useDatos();
  const vigentes = plazosVigentes(plazos);
  return <ul className="divide-y divide-gris-100" data-id="element-440" data-mp="2i076umd0o3bj">
      {expediente.abogadoIds.map((id, i) => {
      const a = abogadoPorId(id);
      if (!a) return null;
      const sucursal = sucursales.find(s => s.id === a.sucursalId);
      const aCargo = vigentes.filter(p => p.responsableId === id && p.expedienteId === expediente.id).length;
      return <li key={id} className="flex items-start gap-4 px-5 py-4" data-id="element-441" data-mp="1za7osjflfohm" data-mpi={i}>
            <Avatar iniciales={inicialesDe(a.nombre)} foto={a.foto} nombre={a.nombre} tamano="md" tono={i === 0 ? 'marino' : 'gris'} data-id="element-442" data-mp="1uafrz0mdln1o" />
            <div className="min-w-0 flex-1" data-id="element-443" data-mp="1kk3axidrsc0a">
              <p className="text-sm font-semibold text-marino-900" data-id="element-444" data-mp="1fmuov6pi3ntr">
                <Link to={`/abogados/${a.id}`} className="hover:underline" data-id="element-445" data-mp="1fkib75qrzzmi">
                  {a.nombre}
                </Link>
                <span className="ml-2 rounded bg-gris-100 px-1.5 py-0.5 text-2xs font-medium uppercase tracking-wide text-gris-600" data-id="element-446" data-mp="16m6agaw73lgc">
                  {i === 0 ? 'Responsable' : 'Apoyo'}
                </span>
              </p>
              <p className="tabular mt-0.5 text-xs text-gris-500" data-id="element-447" data-mp="woibt9vgxtsw">
                Cédula profesional {a.cedula} · {sucursal?.nombre}
              </p>
              <p className="mt-0.5 text-2xs text-gris-400" data-id="element-448" data-mp="2vyguib1hq5ai">{a.especialidades.join(' · ')}</p>
              <div className="mt-2 flex flex-wrap gap-4 text-2xs text-gris-500" data-id="element-449" data-mp="2qzncc5b9dq40">
                <span className="inline-flex items-center gap-1.5" data-id="element-450" data-mp="pazlkypne8mr">
                  <MailIcon className="h-3.5 w-3.5 text-gris-400" aria-hidden="true" data-id="element-451" data-mp="u3kiwa7rj3v1" />
                  {a.correo}
                </span>
                <span className="inline-flex items-center gap-1.5" data-id="element-452" data-mp="fg7nzuw2flrz">
                  <PhoneIcon className="h-3.5 w-3.5 text-gris-400" aria-hidden="true" data-id="element-453" data-mp="keixu5md1wa7" />
                  {a.telefono}
                </span>
              </div>
            </div>
            <div className="shrink-0 text-right" data-id="element-454" data-mp="1d2olp18po1e9">
              <p className="tabular text-xl font-semibold text-marino-900" data-id="element-455" data-mp="1d1dfyvvpgjki">{aCargo}</p>
              <p className="text-2xs text-gris-400" data-id="element-456" data-mp="z1u906emre9s">términos en este expediente</p>
              <Link to={`/abogados/${a.id}`} className="mt-1 inline-block text-2xs font-semibold text-marino-600 hover:text-marino-800" data-id="element-457" data-mp="132nz96fjp55u">
                Ver carga completa
              </Link>
            </div>
          </li>;
    })}
    </ul>;
}